import * as React from 'react';
import { Dropdown, DropdownProps, Form, Input, SemanticWIDTHS } from 'semantic-ui-react';

import Pasaporte from './componentes/Pasaporte';
import Rut, { rutEsInvalido } from './componentes/Rut';

export interface RutDatos {
    tipo: 'rut';
    rut: string;
}

const rutInicial: RutDatos = {
    tipo: 'rut',
    rut: '',
};

export interface PasaporteDatos {
    tipo: 'pasaporte';
    pais?: string;
    pasaporte: string;
}

const pasaporteInicial: PasaporteDatos = {
    tipo: 'pasaporte',
    pais: 'pe',
    pasaporte: '',
};

export type RutPasaporteDatos = RutDatos | PasaporteDatos;

export const rutPasaporteInicial: RutPasaporteDatos = {
    ...rutInicial,
};

export interface RutPasaporteInputProps {
    /** Valor que usará el campo. Requerido. */
    rutPasaporte: RutPasaporteDatos;

    /** Determina si el campo es requerido. Por defecto false. */
    requerido?: boolean;

    ocultarPais?: boolean;

    /** Función que será llamada cuando ocurra un cambio en el componente. Requerido. */
    alCambiar(rutPasaporte: RutPasaporteDatos): void;

    /**
     * Callback que será invocado cada vez que el campo de RUT o pasaporte cambia
     * e indica si el RUT después de la edición es o no válido. Si el
     * campo es requerido un RUT vacío será evaluado como no válido.
     * No se invoca cuando es un pasaporte.
     */
    esValido?(valor: boolean): void;
}

export class RutPasaporteInput extends React.PureComponent<RutPasaporteInputProps> {
    private readonly rutPasaporteOptions = [
        { value: 'rut', text: 'Rut' },
        { value: 'pasaporte', text: 'Pasaporte' },
    ];

    private readonly cambioTipoDropdownStyle = { minWidth: '6em', paddingTop: '9px' };

    public render() {
        const { rutPasaporte, ocultarPais, requerido = false, esValido } = this.props;

        return (
            <Input>
                <Dropdown
                    options={this.rutPasaporteOptions}
                    value={rutPasaporte.tipo}
                    onChange={this.manejarCambioTipo}
                    inline
                    style={this.cambioTipoDropdownStyle}
                />

                {rutPasaporte.tipo === 'rut' ? (
                    <Rut
                        rut={rutPasaporte.rut}
                        alCambiarRut={this.manejarCambioRut}
                        requerido={requerido}
                        esValido={esValido}
                    />
                ) : (
                    <Pasaporte
                        pais={rutPasaporte.pais}
                        pasaporte={rutPasaporte.pasaporte}
                        alCambiarPais={this.manejarCambioPais}
                        alCambiarPasaporte={this.manejarCambioPasaporte}
                        requerido={requerido}
                        ocultarPais={ocultarPais}
                    />
                )}
            </Input>
        );
    }

    private readonly manejarCambioTipo = (_e: {}, { value }: DropdownProps) => {
        const { esValido, requerido } = this.props;

        if (value === 'rut') {
            if (esValido) esValido(!rutEsInvalido(rutInicial.rut, requerido));
            this.realizarCambio({ ...(rutInicial as RutPasaporteDatos) });
        } else {
            if (esValido) esValido(!requerido);
            this.realizarCambio({ ...(pasaporteInicial as RutPasaporteDatos) });
        }
    };

    private readonly manejarCambioRut = (rut: string) => {
        this.realizarCambio({
            ...(this.props.rutPasaporte as RutDatos),
            rut,
        });
    };

    private readonly manejarCambioPasaporte = (pasaporte: string) => {
        const { esValido, requerido } = this.props;
        if (esValido) {
            esValido(pasaporte.length > 0 || !requerido);
        }
        this.realizarCambio({
            ...(this.props.rutPasaporte as PasaporteDatos),
            pasaporte,
        });
    };

    private readonly manejarCambioPais = (pais: string) => {
        this.realizarCambio({
            ...(this.props.rutPasaporte as PasaporteDatos),
            pais,
        });
    };

    private realizarCambio(nuevoState: Partial<RutPasaporteDatos>) {
        const { alCambiar } = this.props;

        if (alCambiar) {
            alCambiar({ ...this.props.rutPasaporte, ...(nuevoState as {}) });
        }
    }
}

export interface RutPasaporteFieldProps extends RutPasaporteInputProps {
    /** Etiqueta que tendrá el <Form.Field>. Por defecto 'Rut/Pasaporte'. */
    label?: string;

    /** Ancho del <Form.Field> en columnas de semantic-ui. */
    width?: SemanticWIDTHS;
}

interface State {
    error: boolean;
}

class RutPasaporteField extends React.Component<RutPasaporteFieldProps, State> {
    public state: State = { error: false };

    public render() {
        const { label = 'Rut/Pasaporte', width, esValido, ...resto } = this.props;

        return (
            <Form.Field required={this.props.requerido} width={width} error={this.state.error}>
                <label>{label}</label>
                <RutPasaporteInput
                    {...resto}
                    esValido={valido => {
                        this.setState({ error: !valido });
                        if (esValido) {
                            esValido(valido);
                        }
                    }}
                />
            </Form.Field>
        );
    }
}

export default RutPasaporteField;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/TurnosYAtenciones/componentes/RutPasaporte/RutPasaporte.tsx